var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdChanged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.47 20.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:#fff;}.cls-1{stroke:#e20613;stroke-miterlimit:10;stroke-width:1.61px;}.cls-2,.cls-3{fill:#e20613;}.cls-3{font-size:9px;font-family:Montserrat-Bold, Montserrat;font-weight:700;}.cls-4{letter-spacing:-0.05em;}.cls-5{letter-spacing:-0.04em;}.cls-6{letter-spacing:0em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "V\xC1LTOZ\xC1S ikon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V\\xC1LTOZ\\xC1S"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.8,
    y: 0.8,
    width: 101.87,
    height: 18.43,
    rx: 9.21,
    ry: 9.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.02,
    cy: 10.02,
    r: 9.21
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(33.22 12.99) scale(1.04 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.08,
    y: 0
  }, "\xC1L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 18.04,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.22,
    y: 0
  }, "OZ"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 36.54,
    y: 0
  }, "\xC1"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.44,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("g", {
    id: "k\\xF6telez\\u0151_mez\\u0151",
    "data-name": "k\\xF6telez\\u0151 mez\\u0151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M442,50.11a1.4,1.4,0,1,1-1.4-1.39A1.34,1.34,0,0,1,442,50.11Zm-.48-2.75h-1.75l-.5-4.66v-3H442v3Z",
    transform: "translate(-430.55 -35.6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdChanged);
export default __webpack_public_path__ + "static/media/prod-changed.02822fee2f68a5cc833715cf8eb83423.svg";
export { ForwardRef as ReactComponent };